import PageHeader from '@/components/global/PageHeader'
import SecuritySettingsPage from '@/components/pages/Settings/account/SecuritySettingsPage/SecuritySettingsPage'
import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$workspaceName/$environment/account-settings/security')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <Stack gap="xl">
      <PageHeader
        title="Security & Access"
        description="Manage your security and access information."
        titleOrder={4}
      />
      <SecuritySettingsPage />
    </Stack>
  )
}
